import { Button, useMediaQuery, useTheme } from "@mui/material";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import DataContext from "../../context/DataContext";
import apiService from "../../api/apiService";
import Timer from "./Timer";
import notifyService from "../../api/notifySerivce";
const VerifyOtp = () => {
  const { handleSubmit } = useForm({ values: {}, mode: "onBlur" });
  const { navigator } = useContext(DataContext);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");

  const handleCheckotp = (value) => {
    setOtp(value);
    if (value.length === 6) {
      setOtpVerified(true);
    }
  };
  const onSubmit = () => {
    var phoneNumber = sessionStorage.getItem("phone");
    let data = {
      phone: Number(phoneNumber),
    };
    console.log(data);
    apiService("login", data, "unauthpost")
      .then((result) => {
        if (result?.data?.response?.responseStatus === "Success") {
          if (result.data.id === 0) {
            navigator("/register");
          } else {
            if (result.data.roleId === 1) {
              sessionStorage.setItem("loginBtn", false);
              sessionStorage.setItem("name", result.data.name);
              sessionStorage.setItem("token", result.data.token);
              sessionStorage.setItem(
                "forceChangePassword",
                result.data.forceChangePassword
              );
              sessionStorage.setItem("roleId", result.data.roleId);
              sessionStorage.setItem("name", result.data.name);
              navigator("/admin/list");
            } else {
              navigator("/register");
            }
          }
          notifyService(
            "success",
            "Success",
            result.data.response.responseMessage
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const onError = (event) => {};
  const [seconds, setSeconds] = useState(60);
  const [minutes, setMinutes] = useState(4);
  const resenOtp = () => {
    setOtp("");
    var phoneNumber = sessionStorage.getItem("phone");
    let data = {
      phone: Number(phoneNumber),
    };
    console.log(data);
    apiService("login", data, "unauthpost").then((result) => {
      if (result?.data?.response?.responseStatus === "Success") {
        notifyService(
          "success",
          "Success",
          result.data.response.responseMessage
        );
        setSeconds(60);
        setMinutes(4);
      }
    });
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div class="login-page">
      <div class="container-fluid">
        <div className="row justify-content-center align-items-center">
          <div
            className="col-lg-6 col-md-6 col-12 p-0"
            style={isMobile ? { display: "none" } : { display: "block" }}
          >
            <img
              src="/images/auth-bg.png"
              alt="IMG"
              className="img-fluid login-img"
            />
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="">
              <img
                src="/images/govt.png"
                alt=""
                className="img-fluid logo-img mb-2"
              />
              <img
                src="./images/YF_transparent.png"
                className="img-fluid ml-auto logo-img"
                alt=""
              />
            </div>
            <form
              className={isMobile ? "validate-form" : "validate-form p-5"}
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <div
                className={!isMobile ? "login-form mx-5" : "login-form"}
                // style={!isMobile && { margin: "0 3rem" }}
              >
                <div>
                  <h3 class="login100-form-title mb-5">Verify OTP</h3>
                </div>
                <div>
                  <div className="base">
                    <div className=" otp-base">
                      <OTPInput
                        value={otp}
                        onChange={handleCheckotp}
                        numInputs={6}
                        renderSeparator={<span>&nbsp;&nbsp;</span>}
                        shouldAutoFocus={true}
                        renderInput={(props) => (
                          <input {...props} autoFocus type="password" />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-12">
                  <Timer
                    resent={resenOtp}
                    seconds={seconds}
                    setSeconds={setSeconds}
                    minutes={minutes}
                    setMinutes={setMinutes}
                  />
                </div>
                <div className="col-lg-12 col-md-12 col-12 text-center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      mt: 2,
                      py: 1.5,
                      textTransform: "none",
                      background: "#dd1818",
                      "&:hover": { background: "#000", color: "#fff" },
                    }}
                    disabled={!otpVerified}
                  >
                    Verify Otp
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
